import React, { useEffect,useState} from 'react';
import { Button, Modal } from 'react-bootstrap';
import {useTranslation} from 'react-i18next';
import AttendanceEventDatatable from './AttendanceEventDatatable';
import AttendanceEventModal from './AttendanceEventModal';






  const AttendanceDetailModal = (props) => {

   
    const [eventRecordId, setEventRecordId] = useState();
    const [isOpen, setIsOpen] = useState(false);
    const [show, setShow] = useState(false);
    const [checkTime, setCheckTime] = useState(null);
    const [t] = useTranslation();

    const hideModal = () => {
      setIsOpen(false);
      showChanged(false);
    };

    const showChanged = (newStatus) => {
      props.parentCallback(newStatus);
    }

   
    useEffect(() => {      
      setIsOpen(props.modal);    
    }, [props.modal])

    const handleCallback = (id) => {
      setEventRecordId(id);
      setShow(true);
    }

    const modalCallback = (show) =>{
      setShow(show);
      setCheckTime(Date.now());
    }


    return (
      <>    
        <div className="modal-container">
                  <Modal
                    show={isOpen}
                    onHide={hideModal}
                    container={this}
                    aria-labelledby="contained-modal-title"
                    centered
                    size="lg"
                
                  >                    
                    <Modal.Header closeButton>
                      <Modal.Title id="contained-modal-title">{t('attendance.label.event')}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>


                         <AttendanceEventDatatable            
                             parentCallback={handleCallback}    
                             entityId={props.selectedRecord}       
                             checkTime={checkTime}                     
                        />
        
                        <AttendanceEventModal 
                          modal={show}
                          parentCallback={modalCallback}
                          selectedRecord={eventRecordId}         
                          attendanceDetailId={props.selectedRecord}             
                        />
                      
                        <Button
                          bsStyle="primary"
                        //  bsSize="large"
                          className="ml-3 mt-3"
                          onClick={() => handleCallback('')} 
                        >
                          <i class="fas fa-plus"></i>
                        </Button>
      
                        
                    </Modal.Body>
                   
                                        
                  </Modal>                                      
                </div>               
            
      </>
    );
  };

 export default AttendanceDetailModal;